namespace GeniuzPOS.PosShift {
    export interface PsPriceOverrideTranForm {
        DocNo: Serenity.StringEditor;
        PluCode: Serenity.LookupEditor;
        PluDesc: Serenity.StringEditor;
        PosId: Serenity.LookupEditor;
        Qty: Serenity.DecimalEditor;
        UnitPrice: Serenity.DecimalEditor;
        OverridePrice: Serenity.DecimalEditor;
        PriceOverrideId: Serenity.IntegerEditor;
        CashierId: Serenity.LookupEditor;
        MgrCashierId: Serenity.LookupEditor;
        CreateBy: Serenity.StringEditor;
        CreateDate: Serenity.DateEditor;
    }

    export class PsPriceOverrideTranForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.PsPriceOverrideTran';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPriceOverrideTranForm.init)  {
                PsPriceOverrideTranForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.DateEditor;

                Q.initFormType(PsPriceOverrideTranForm, [
                    'DocNo', w0,
                    'PluCode', w1,
                    'PluDesc', w0,
                    'PosId', w1,
                    'Qty', w2,
                    'UnitPrice', w2,
                    'OverridePrice', w2,
                    'PriceOverrideId', w3,
                    'CashierId', w1,
                    'MgrCashierId', w1,
                    'CreateBy', w0,
                    'CreateDate', w4
                ]);
            }
        }
    }
}
